module.exports = require('./dist');



//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-html2canvas/index.js
// module id = 1864
// module chunks = 116